import React, { Component } from "react";
import { renderMarkup } from "../utils.js";
import quotes from "../assets/quotes.svg";
class TestimonialBlock extends Component {
  render() {
    const { data } = this.props;
    return (
      <div className="testimonial-block">
        <img src={quotes} alt="Quote" />
        <div
          className="testimonial-content"
          dangerouslySetInnerHTML={renderMarkup(data.content.rendered)}
        />
      </div>
    );
  }
}

export default TestimonialBlock;



// WEBPACK FOOTER //
// ./src/components/TestimonialBlock.js